import { SandboxComposite } from '../../../Constants/Types';
import { compareBooleans, compareDates, compareStrings, compareNumbers } from 'src/Util/TableComparers';

const withTitleFallback = (a: SandboxComposite, b: SandboxComposite, primaryComparison: number) => {
  if (primaryComparison !== 0) return primaryComparison;
  return compareStrings(a.title, b.title);
};

export const compareSandboxes = (a: SandboxComposite, b: SandboxComposite, sortBy: keyof SandboxComposite): number => {
  switch (sortBy) {
    case 'title':
      return compareStrings(a.title, b.title);
    case 'isShared':
      return withTitleFallback(a, b, compareBooleans(a.isShared, b.isShared));
    case 'userName':
      return withTitleFallback(a, b, compareStrings(a.userName, b.userName));
    case 'organization':
      return withTitleFallback(a, b, compareStrings(a.organization, b.organization));
    case 'userEnabled':
      return withTitleFallback(a, b, compareBooleans(a.userEnabled, b.userEnabled));
    case 'userLastActive':
      return withTitleFallback(a, b, compareDates(a.userLastActive, b.userLastActive));
    case 'lastAccessed':
      return withTitleFallback(a, b, compareDates(a.lastAccessed, b.lastAccessed));
    case 'accessCount':
      return withTitleFallback(a, b, compareNumbers(a.accessCount, b.accessCount));
    case 'lastModified':
    case 'timeCreated':
      return withTitleFallback(a, b, compareDates(a.lastModified, b.lastModified));
    default:
      return 0;
  }
};